import { useTranslation } from "react-i18next";
import Plus from "lucide-react/dist/esm/icons/plus.js";
import { cn } from "@shared/lib/utils";
import { Button } from "@shared/ui/button";
import { PaywallGate } from "@shared/components/paywall";
import { WalletBalanceBadge } from "../WalletBalanceBadge";
import { localizedPaymentPath } from "../../../utils/localizedRoutes";

export interface WalletHeaderControlsProps {
  className?: string;
}

/**
 * Dashboard-header payment hub: the credit-balance chip (links to /wallet) plus
 * a "Top up" button (links to /pricing). Self-gated behind <PaywallGate>, so it
 * renders nothing when payments are disabled. WalletBalanceBadge is also paywall
 * gated internally — the nesting is harmless (same flag).
 */
export function WalletHeaderControls({ className }: WalletHeaderControlsProps) {
  const { t } = useTranslation("payment");

  return (
    <PaywallGate>
      <div className={cn("flex items-center gap-2", className)}>
        <WalletBalanceBadge />
        <Button size="sm" asChild>
          <a href={localizedPaymentPath("/pricing")}>
            <Plus className="me-1 h-4 w-4" />
            {t("wallet.topUp", "Top up")}
          </a>
        </Button>
      </div>
    </PaywallGate>
  );
}
